<template>
  <el-card>
    <div class="row">
      <ColumnDataValueTotal background="bg-gradient-orange" icon="fa fa-money" title="Dinheiro" :value="info.money"
        color="blue" />
      <ColumnDataValueTotal background="bg-gradient-blue" icon="fa fa-qrcode" title="PIX" :value="info.pix"
        color="orange" />
      <ColumnDataValueTotal background="bg-gradient-gray" icon="ni ni-credit-card" title="Cartão Crédito"
        :value="info.credit" color="teal" />
      <ColumnDataValueTotal background="bg-gradient-green" icon="fa fa-credit-card-alt" title="Cartão Débito"
        :value="info.debit" color="green" />
    </div>
    <br />
    <el-card>
      <el-form label-width="220px">
        <el-row :gutter="5" justifty="center">
          <el-col :xs="24" :sm="16" :md="12" :lg="8" :xl="6">
            <el-form-item label="Valor inicial">
              <el-input type="number" :disabled="true" :controls="false" :min="0" class="number"
                pattern="^\\$?(([1-9](\\d*|\\d{0,2}(,\\d{3})*))|0)(\\.\\d{1,2})?$" v-model="info.start"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5" justifty="center">
          <el-col :xs="24" :sm="16" :md="12" :lg="8" :xl="6">
            <el-form-item label="Dinheiro no caixa"
              error="Conte o dinheiro do caixa e informe aqui o valor para realizar o fechamento">
              <el-input type="number" pattern="^\\$?(([1-9](\\d*|\\d{0,2}(,\\d{3})*))|0)(\\.\\d{1,2})?$" :controls="false"
                :disabled="info.status === '3' || info.status === '4' || info.status === '5' || info.status === '6'"
                v-on:keyup.native.enter="conference" class="number" :min="0" v-model="value"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br />
        <el-form-item style="text-align: center">
          <el-button @click="$router.replace({ name: history })">Voltar</el-button>
          <el-button type="warning" v-show="info.status !== '0'" @click="conference()">Conferir</el-button>
        </el-form-item>
      </el-form>
      <PdvCloseCashierConference ref="cashierConference" :value="value" :status="info.status" @conference="conference"
        @add="deposit" @authorization="info.status = '4'" @refresh="fetch" />
    </el-card>
  </el-card>
</template>
<script>
import { PdvCashierService } from "@/services/pdv/pdv.cashier.services";
import ColumnDataValueTotal from "../../components/data/ColumnDataValueTotal.vue";
import PdvCloseCashierConference from './PdvCloseCashierConference.vue';

export default {
  props: ["balance"],
  data() {
    return {
      value: 0,
      history: 'pdv.call',
      info: {
        start: 0,
        balance: 0,
        money: 0,
        pix: 0,
        credit: 0,
        debit: 0,
        status: '0',
        conferenceMoney: 0,
      }
    };
  },
  mounted() {
    const vm = this;
    vm.history = vm.$route.params.back ? vm.$route.params.back : vm.history;
    vm.fetch();
  },
  methods: {
    fetch() {
      const vm = this;
      vm.history = vm.$route.params.back ? vm.$route.params.back : vm.history;
      const loading = vm.$loading(vm.$options.loading);
      PdvCashierService.info()
        .then((response) => {
          vm.info = response.data;
          if (vm.info.status === '3' || vm.info.status === '4' || vm.info.status === '5' || vm.info.status === '6') {
            vm.value = (+vm.info.balance).toFixed(2);
            setTimeout(() => {
              vm.$refs.cashierConference.open();
            }, 300)
          }
        })
        .catch((error) => this.$message({ type: "error", message: error }))
        .finally(() => loading.close());
    },
    deposit(value) {
      const vm = this;
      vm.value = +vm.value + +value;
      vm.conference();
    },
    conference() {
      const vm = this;
      vm.info.status = '3';
      vm.$refs.cashierConference.open();
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PdvService.open(vm.value).then((response) => {
        vm.$store.commit("pdv/id", response);
        this.dialog = false;
      }).catch((error) => this.$message({ type: "error", duration: 5000, message: error, offset: 45 }))
        .finally(() => loading.close());
    }
  },
  components: {
    ColumnDataValueTotal,
    PdvCloseCashierConference,
  }
}
</script>

<style scoped>
.el-alert__title {
  font-size: 13px !important;
}
</style>